import { render, staticRenderFns } from "./envdetails.vue?vue&type=template&id=4112c1a8&"
import script from "./envdetails.vue?vue&type=script&lang=ts&"
export * from "./envdetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports